export const translate = value => {
  const translationKeys = {
    good: 'Bom',
    regular: 'Regular',
    bad: 'Ruim',
    pending: 'Pendente',
    scheduled: 'Programada',
    sended: 'Enviada',
    acknowledged: 'Entendido',
    completed: 'Concluído',
    read: 'Lida',
    low: 'Baixo',
    medium: 'Médio',
    high: 'Alto',
  }

  return translationKeys[value] || value
}

export const translateEventType = value => {
  const translationKeys = {
    caffeine: 'Cafeína',
    sleep: 'Sono',
  }

  return translationKeys[value] || value
}
